import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NemHandelComponent } from './nem-handel/nem-handel.component';
import { DirectivesModule } from '../directives/directives.module';

@NgModule({
  declarations: [
    NemHandelComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  imports: [
    CommonModule,
    DirectivesModule
  ],
  exports: [NemHandelComponent]
})
export class NemHandelModule {
  customElementComponent: Type<any> = NemHandelComponent;
}
